import { useEffect } from 'react';
import { getEnvIcon } from 'shared/utils/environment';

/**
 * Sets `document.title` to "<env icon><company> - <title>" while mounted, and
 * restores it to the company name (or "Recovr") on unmount.
 */
export const useDocumentTitle = (title: string, companyName?: string) => {
  useEffect(() => {
    document.title = `${getEnvIcon()}${companyName} - ${title}`;

    return () => {
      document.title = `${getEnvIcon()}${companyName ?? 'Recovr'}`;
    };
  }, [title, companyName]);
};
